module.exports = __webpack_public_path__ + "img/CRC2_Endothelial.8dba3d92.png";